import React from 'react';

/**
 * DeleteSelectedSpacesButton component for deleting all selected spaces
 * 
 * @param {Object} props - Component props
 * @param {Array} props.selectedSpaces - Array of selected spaces
 * @param {Function} props.onDelete - Function to call when deleting the spaces
 * @returns {JSX.Element} DeleteSelectedSpacesButton component
 */
const DeleteSelectedSpacesButton = ({ selectedSpaces, onDelete }) => {
  // Don't render if no spaces are selected
  if (!selectedSpaces || selectedSpaces.length === 0) {
    return null;
  }
  
  return (
    <button 
      className="delete-selected-button"
      onClick={(e) => {
        e.stopPropagation();
        // Confirm before deleting multiple spaces
        if (selectedSpaces.length > 1) {
          if (window.confirm(`Delete ${selectedSpaces.length} selected spaces?`)) {
            onDelete();
          }
        } else {
          // For single item, delete without confirmation
          onDelete();
        }
      }}
      title={`Delete ${selectedSpaces.length} selected space${selectedSpaces.length > 1 ? 's' : ''}`}
    >
      🗑️ Delete {selectedSpaces.length} Selected
    </button>
  );
};

export default DeleteSelectedSpacesButton; 